import React from 'react';

type Props = {
  top?: number | 'auto';
  bottom?: number | 'auto';
  left?: number | 'auto';
  right?: number | 'auto';
};

export const MarginComponent: React.FC<Props> = (props) => {
  const { children, top, bottom, left, right } = props;

  const style = React.useMemo<React.CSSProperties>(() => {
    return {
      marginTop: top,
      marginBottom: bottom,
      marginLeft: left,
      marginRight: right,
    };
  }, [bottom, left, right, top]);

  return <div style={style}>{children}</div>;
};
